export const CAN_IMPERSONATE_STORAGE_KEY = 'CAN_IMPERSONATE';
export const IMPERSONATE_UID_STORAGE_KEY = 'IMPERSONATE_UID';

const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);

export const canImpersonate = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const rawValue = window.localStorage.getItem(CAN_IMPERSONATE_STORAGE_KEY);
  if (!rawValue) {
    return false;
  }

  return TRUE_VALUES.has(rawValue.toLowerCase());
};

export const getImpersonatedUid = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem(IMPERSONATE_UID_STORAGE_KEY);
};

export const setImpersonatedUid = (uid: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(IMPERSONATE_UID_STORAGE_KEY, uid);
};

export const clearImpersonatedUid = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(IMPERSONATE_UID_STORAGE_KEY);
};

export const isImpersonatingUser = (authUid?: string): boolean => {
  if (!canImpersonate()) {
    return false;
  }

  const impersonatedUid = getImpersonatedUid();
  return !!impersonatedUid && impersonatedUid !== authUid;
};
